import angular from 'angular';

let inject = [
    'BlogService',
    'SharedService',
    '$stateParams'
];

class BlogController {
    constructor(BlogService,SharedService,$stateParams) {
        this.BlogService = BlogService;
        this.$stateParams = $stateParams;
        this.SharedService =SharedService;

        this.params ={};
        this.tagSlug = this.$stateParams.tagSlug || '';
        this.categorySlug = this.$stateParams.categorySlug || '';
        this.searchWord = this.$stateParams.searchWord || '';
        this.pageName = "PAG-45";
        this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
          this.cmsData = response;
        });
        this.blogs=[];
      this.currentPage= 1;
      this.pageSize= 5;

    }

    $onInit() {
      this.getPosts();

      this.BlogService.getPanelBlog().then(response => {
        this.recenPost=response.recentposts;
        this.categories=response.categories;
        this.tags=response.tags;

      });
    }

    getPosts(reset=false){
      if (reset){
        this.currentPage= 1;
        this.pageSize= 5;
      }
      this.tagSlug ? this.params.tag=this.tagSlug:null;
      this.categorySlug ? this.params.category=this.categorySlug:null;
      this.searchWord ? this.params.searchword=this.searchWord:null;
      this.params.limit=this.pageSize;
      this.params.page = this.currentPage;


      this.BlogService.getPosts(this.params).then(response => {
        this.blogs=response.posts;
        this.searchedWord=response.searchword;
        this.tagSelected=response.tag;
        this.categorySelected=response.category;
        //Pagination
        this.totalPosts= response.total;
        this.currentPage= response.page;
        this.pageSize= response.limit;
        this.totalPages=Integer(this.totalPosts/this.pageSize);


      });
    }



}

BlogController.$inject = inject;

export default BlogController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog.controller.js
 **/